const passwordPattern = {
  number: /\d/,
  specialChar: /[!@#$%^&*(),.?":{}|<>]/,
  uppercase: /[A-Z]/,
  lowercase: /[a-z]/,
};

function validatePassword(password) {
  if (!password || !password.length) {
    return 'Wachtwoord is niet ingevuld.';
  }

  if (password.length < 8) {
    return 'Wachtwoord moet minstens 8 tekens lang zijn.';
  }

  if (!passwordPattern.number.test(password)) {
    return 'Wachtwoord moet minstens 1 nummer bevatten.';
  }

  if (!passwordPattern.specialChar.test(password)) {
    return 'Wachtwoord moet minstens 1 speciaal teken bevatten.';
  }

  if (!passwordPattern.uppercase.test(password)) {
    return 'Wachtwoord moet minstens 1 hoofdletter bevatten.';
  }

  if (!passwordPattern.lowercase.test(password)) {
    return 'Wachtwoord moet minstens 1 kleine letter bevatten.';
  }

  return null;
}

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function isValidEmail(email) {
  return emailPattern.test(email);
}

export {
  validatePassword,
  isValidEmail,
};
